export default __webpack_public_path__ + "static/media/phone.513f9ebf.png";